'use strict';

import FluxConstant from 'flux-constant';


export default FluxConstant.set([
    'GET_TOS_DETAILS',
    'GET_TOS_DETAILS_RESPONSE',
    'GET_TOS_AGREED_RESULTS',
    'GET_TOS_AGREED_RESULTS_RESPONSE',
    'CREATE_NEW_TOS_AGREED',
    'CREATE_NEW_TOS_AGREED_RESPONSE',
    'GET_MY_ACCOUNT',
    'GET_MY_ACCOUNT_RESPONSE',
    'GET_BT_TOKEN',
    'GET_BT_TOKEN_RESPONSE',
    'CREATE_BT_CLIENT',
    'CREATE_BT_CLIENT_RESULT',
    'RESET_BT_CLIENT',
    'CREATE_HOSTED_FIELDS',
    'CREATE_HOSTED_FIELDS_RESULT',
    'RESET_HOSTED_FIELDS',
    'SUBMIT_HOSTED_FIELDS',
    'SUBMIT_HOSTED_FIELDS_RESPONSE',
    'SUBMIT_LOCAL_FIELDS',
    'SUBMIT_LOCAL_FIELDS_RESPONSE',
    'POST_TOKEN_AND_CART',
    'POST_TOKEN_AND_CART_RESPONSE',
    'POST_TOKEN_AND_CARD_RESET',
    'POST_TOKEN_AND_CARD',
    'POST_TOKEN_AND_CARD_RESPONSE',
    'POST_TOKEN_AND_CARD_UPDATE',
    'POST_TOKEN_AND_CARD_UPDATE_RESPONSE',
    'POST_TOKEN_AND_CARD_UPDATE_RESET',
    'DELETE_CARD',
    'DELETE_CARD_RESPONSE',
    'POST_TOKEN_AND_ORGANIZATION',
    'POST_TOKEN_AND_ORGANIZATION_RESPONSE',
    'VALIDITY_CHANGE',
    'CARD_CHANGE',
    'SIGN_OUT',
    'SIGN_OUT_RESPONSE',
    'GOTO_PAYMENT_DETAILS',
    'GOTO_ORGANIZATION_DETAILS'
]);
